export default "__VITE_ASSET__6949c449__"